import VehiclesList from "./VehiclesList";

export default VehiclesList;